import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AngularMaterialModule } from 'src/app/material.module';

export interface IDocumentPreviewData {
  url: string;
  fileName: string;
  isImage: boolean;
}

@Component({
  selector: 'app-document-preview-dialog',
  templateUrl: './document-preview-dialog.component.html',
  styleUrls: ['./document-preview-dialog.component.less'],
  standalone: true,
  imports: [CommonModule, AngularMaterialModule]
})
export class DocumentPreviewDialogComponent {

  isImage: boolean;
  fileName: string;
  safeImageUrl: SafeUrl;
  safePdfUrl: SafeResourceUrl;

  constructor(
    private dialogRef: MatDialogRef<DocumentPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDocumentPreviewData,
    private sanitizer: DomSanitizer
  ) {
    this.isImage = data.isImage;
    this.fileName = data.fileName;
    if (data.isImage) {
      this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(data.url);
    } else {
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
